import { IoIosArrowDown } from 'react-icons/io'
import { Button, Container } from './styles'
import { useState } from 'react'
import { MdLock, MdOndemandVideo, MdOutlineMenuBook } from 'react-icons/md'
import { ICourse, ILesson, IModule } from 'pages/Lesson/hooks/use-get-menu-content/types'
import ModalFreemium from 'components/ModalFreemium'
import Direcao from 'assets/logos/direcao-square.png'
import { createModalPortal } from 'utils/createModalPortal'
import { TimeIcons } from '../LessonDisclosure/styles'
import { formatSeconds } from 'utils/formatSeconds'
import { WrapperContainer } from 'pages/Course/components/ModuleAcordeon/styles'

interface IProps {
  lesson: ILesson
  course: ICourse
  module: IModule
}

const FreemiumLockedLesson = (props: IProps) => {
  const { lesson, course, module } = props

  const [isOpen, setIsOpen] = useState(false)

  const renderFreemiumModal = () => {
    const moduleProps = {
      _id: module._id,
      name: module.name,
      icon: course.icon ?? Direcao,
      discount: 0,
      permanentLink: module.permanentLink,
      qtd_videos: module.total.video?.amount,
      qtd_pdf: module.total.excerto?.amount,
    }

    const courseProps = {
      _id: course._id,
      name: course.name,
      icon: course.icon ?? Direcao,
      discount: course.discount,
      permanentLink: course.permanentLink,
      qtd_videos: course.totalCourse.videos?.amount,
      qtd_pdf: course.totalCourse.excertos?.amount,
    }

    return createModalPortal(
      <WrapperContainer>
        <ModalFreemium
          module={moduleProps}
          course={courseProps}
          subscription={course?.isFreemium && course?.isSubscription}
          setOpenModal={setIsOpen}
        />
      </WrapperContainer>
    )
  }

  const renderTimeIcons = () => (
    <TimeIcons>
      {lesson.readingTime > 0 && (
        <div className="wrapper">
          <MdOutlineMenuBook size={16} />
          {formatSeconds(lesson.readingTime)}
        </div>
      )}

      {lesson.videoTime > 0 && (
        <div className="wrapper">
          <MdOndemandVideo size={16} />
          {formatSeconds(lesson.videoTime)}
        </div>
      )}
    </TimeIcons>
  )

  return (
    <>
      <Container>
        <Button onClick={() => setIsOpen((state) => !state)}>
          <MdLock className="lock" />

          <div className="group">
            <p className="title">
              <span>{lesson.position}.</span> <span className="name">{lesson.name}</span>
            </p>

            {renderTimeIcons()}
          </div>
          <IoIosArrowDown className="arrow" />
        </Button>
      </Container>
      {isOpen && renderFreemiumModal()}
    </>
  )
}

export default FreemiumLockedLesson
